import { defineComponent as _defineComponent } from 'vue'
import { type PropType, computed, useStore } from "@nuxtjs/composition-api";

import { useTranslate } from "@/composables";
import { getAmplitudeStore } from "@/store/amplitude";
import { useCreatorShop } from "@/store/creator-shop";
import { getGiftGuidesStore } from "@/store/gift-guides";
import { getProfilesStore } from "@/store/profiles";


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftGuideTile',
  props: {
  giftGuideId: {
    type: String,
    required: true,
  },
  maxWidth: {
    type: [String, Number],
    default: 288,
  },
  referringComponent: {
    type: String,
    required: true,
  },
  small: {
    type: Boolean,
    default: true,
  },
  showAudience: {
    type: Boolean,
    default: true,
  },
  width: {
    type: String as PropType<string | undefined>,
    default: undefined,
  },
},
  setup(__props) {

const props = __props;



const store = useStore();
const { t } = useTranslate();

const giftGuide = computed(() => {
  return getGiftGuidesStore(store).giftGuides[props.giftGuideId];
});

const displayName = computed(() => {
  const profileId = giftGuide.value?.profileId;
  return profileId ? getProfilesStore(store)?.profiles[profileId]?.displayName || "" : undefined;
});

const translatedAttributes = computed(() => {
  const giftGuideStore = getGiftGuidesStore(store);
  const attributes = giftGuideStore.giftGuides[props.giftGuideId]?.attributes;

  if (attributes) {
    return giftGuideStore.localizedAttributes(attributes);
  }

  return null;
});

const audienceText = computed(() => translatedAttributes.value?.recipient ?? "");

const subtitle = computed(() => {
  const audience = props.showAudience
    ? audienceText.value
    : t("By {displayName}", { displayName: displayName.value ?? "" }).value;
  const guide = giftGuide.value;
  const productCount = guide?.productCount
    ? t("{count} Products", { count: guide?.productCount?.toString() ?? "" }).value
    : "";
  return audience || productCount;
});

function setReferringComponentAndTab() {
  getAmplitudeStore(store).setReferringComponent(props.referringComponent);
  useCreatorShop().setReferringShopTab();
}

return { __sfc: true,props, store, t, giftGuide, displayName, translatedAttributes, audienceText, subtitle, setReferringComponentAndTab }
}

})